import { PRODUCT, REFER_A_FRIEND_OFFER_ID } from '@ahmdigital/constants';

import { nextReduxWrapper } from '../../../src/client/store/create-store';
import fetchProductsFromParams from '../../../src/client/models/product/fetch-products-from-params';
import Page from '../../../src/client/pages/offers/refer-a-friend';

export const getServerSideProps = nextReduxWrapper.getServerSideProps((store) => async ({ query, req }) => {
  const params = {
    offerId: REFER_A_FRIEND_OFFER_ID.FRIEND,
    productIds: [
      PRODUCT.AMBULANCE_AND_ACCIDENT_BASIC_EXCESS_750_BLACK_50_SAVER_EXTRAS,
      PRODUCT.BRONZE_PLUS_EVERYDAY_EXCESS_750_BLACK_60_EXTRAS,
      PRODUCT.ADVANCED_HOSPITAL_GOLD_EXCESS_750_SUPER_EXTRAS,
    ],
  };

  await fetchProductsFromParams(store.getState(), store.dispatch, params);

  return {
    props: {
      actions: {},
      location: {
        hash: '',
        pathname: req.url,
        query,
        search: '',
      },
      match: { params },
    },
  };
});

export default Page;
